import * as THREE from 'three';
import ObjectArrayView from '../../generic/container/ObjectArrayView';
import ObjectsByName from '../../generic/container/ObjectsByName';
import PolyMesh from '../model/PolyMesh';
import PolyMap from '../model/PolyMap';

export default function Plane(width, height, widthSegments, heightSegments) {

  widthSegments = Math.floor(widthSegments);
  heightSegments = Math.floor(heightSegments);

  const faceRangeOffsets = new Uint32Array(widthSegments * heightSegments + 1);
  const faceValueIndices = new Uint32Array(widthSegments * heightSegments * 4);
  const values = new ObjectArrayView(THREE.Vector3, (widthSegments + 1) * (heightSegments + 1));
  const normals = new ObjectArrayView(THREE.Vector3, (widthSegments + 1) * (heightSegments + 1));
  const uvValues = new ObjectArrayView(THREE.Vector2, (widthSegments + 1) * (heightSegments + 1));

  const segment_width = width / widthSegments;
  const segment_height = height / heightSegments;

  const width_half = width / 2;
  const height_half = height / 2;

  let iz, ix;

  const newValue = new THREE.Vector3();
  const newNormal = new THREE.Vector3(0, 1, 0);
  const newUV = new THREE.Vector2();

  //populate FaceRangeOffsets
  for (iz = 0, ix = 0; iz < faceRangeOffsets.length; iz++, ix += 4) {
    faceRangeOffsets[iz] = ix;//0 4 8 12 16 20 ...
  }

  //populate faceValueIndices
  for (iz = 0; iz < heightSegments; iz++) {
    for (ix = 0; ix < widthSegments; ix++) {
      faceValueIndices[(iz * widthSegments + ix) * 4]     = iz * (widthSegments + 1) + ix;
      faceValueIndices[(iz * widthSegments + ix) * 4 + 1] = iz * (widthSegments + 1) + ix + 1;
      faceValueIndices[(iz * widthSegments + ix) * 4 + 2] = (iz + 1) * (widthSegments + 1) + ix + 1;
      faceValueIndices[(iz * widthSegments + ix) * 4 + 3] = (iz + 1) * (widthSegments + 1) + ix;
    }
  }

  //populate values, normals, and uv values
  for (iz = 0; iz < heightSegments + 1; iz++) {

    //calculate z coord
    const z = iz * segment_height - height_half;

    for (ix = 0; ix < widthSegments + 1; ix++) {
      //calculate x coord
      const x = ix * segment_width - width_half;

      //set value
      newValue.set(x, 0, -z);
      values.setAt((iz * (widthSegments + 1) + ix), newValue);

      //set normal
      normals.setAt((iz * (widthSegments + 1) + ix), newNormal);

      //set uv value
      newUV.set(ix / widthSegments, iz / heightSegments);
      uvValues.setAt((iz * (widthSegments + 1) + ix), newUV);

    }

  }

  const positionsMap = new PolyMap({
    faceRangeOffsets: faceRangeOffsets,
    faceValueIndices: faceValueIndices,
    values: values,
  });

  const normalMap = new PolyMap({
    faceRangeOffsets: faceRangeOffsets,
    faceValueIndices: faceValueIndices,
    values: normals,
  });

  const uvMap = new PolyMap({
    faceRangeOffsets: faceRangeOffsets,
    faceValueIndices: faceValueIndices,
    values: uvValues,
  });

  const uvMapsByName = new ObjectsByName();
  const name = 'default';
  uvMapsByName.set(name, uvMap);

  const polyMesh = new PolyMesh();
  polyMesh.faceRangeOffsets = faceRangeOffsets;
  polyMesh.positions = positionsMap;
  polyMesh.normalMap = normalMap;
  polyMesh.uvMaps = uvMapsByName;

  return polyMesh;
};



// WEBPACK FOOTER //
// ./src/polyMesh/geometric/primitives/Plane.js